import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import styles from './style.module.less';
const NoRecordingBanner = () => (_jsxs("div", { className: styles.noRecordingBanner, children: [_jsx(InfoCircleOutlined, { className: styles.noRecordingBannerIcon }), _jsx(Typography.Text, { className: styles.noRecordingBannerText, children: txt('projectWithoutRecordingInfo') })] }));
export default NoRecordingBanner;
